import { query } from '@confluence/query-preloader-tools';

import { FooterCreateButtonsQuery } from '../src/queries/FooterCreateButtonsQuery.graphql';

export function preloadFooterCreateButton(spaceKey: string) {
	return query({
		query: FooterCreateButtonsQuery,
		variables: {
			errorPolicy: 'all',
			spaceKey,
		},
	});
}
